export function getEmail(user) {
    var emailObj = user.emails.find(function (e) { return e.verified; });
    if (!emailObj) {
        throw new Error('no verified email found');
    }
    return emailObj.address;
}
//# sourceMappingURL=helpers.js.map